import React from "react";
import {
  LoadingWrapper,
  Container,
  LoadingContainer,
  ItemContainer,
  Headline,
} from "../styles/components/Global/Loader";
import LotusLogo from "./Logo";

const Loader = () => {
  return (
    <Container id="loader">
      <LoadingWrapper id="progress" className="active">
        <Container $height="100vh" $justify="center" $flex>
          <LoadingContainer>
            <ItemContainer>
              <LotusLogo
                source="https://www.datocms-assets.com/40484/1695229066-lotus-logo.png"
                link={false}
              />
            </ItemContainer>
            <ItemContainer>
              <Headline id="coordinates" $underline>
                48.8566° N, 2.3522° E
              </Headline>
            </ItemContainer>
            <ItemContainer id="webcam-activate" $fade>
              <Headline $small>Please activate your webcam</Headline>
            </ItemContainer>
          </LoadingContainer>
        </Container>
      </LoadingWrapper>
    </Container>
  );
};

export default Loader;
